import { z } from 'zod';
import { FIELD_LIMITS } from './constants.js';
import type { AdminRole } from './enums.js';

export const loginSchema = z.object({
  email: z.string().trim().toLowerCase().max(FIELD_LIMITS.email).pipe(z.email('Enter a valid email address')),
  password: z.string().min(1, 'Password is required').max(FIELD_LIMITS.password),
});
export type LoginInput = z.infer<typeof loginSchema>;

/**
 * Minimum for a first admin created from the CLI or environment. Deliberately
 * length-based rather than a composition rule.
 */
export const adminPasswordSchema = z
  .string()
  .min(12, 'Use at least 12 characters')
  .max(FIELD_LIMITS.password);

export const adminCreateSchema = z.object({
  email: z.string().trim().toLowerCase().max(FIELD_LIMITS.email).pipe(z.email()),
  name: z.string().trim().min(1).max(FIELD_LIMITS.name),
  password: adminPasswordSchema,
});
export type AdminCreateInput = z.infer<typeof adminCreateSchema>;

export interface AdminUserDto {
  id: string;
  email: string;
  name: string;
  role: AdminRole;
  lastLoginAt: string | null;
}

export interface AdminSessionDto {
  user: AdminUserDto;
  csrfToken: string;
  expiresAt: string;
}
